import { createSelector } from '@ngrx/store';
import { AppState } from '../../store/app.states';
import { IMemberJoinState } from './state';

const state = (state: AppState) => state.memberJoinState;

export const memberJoin_CurrentStep = createSelector(
  state,
  (state: IMemberJoinState) => state.currentStep
);

export const memberJoin_ErrorPage = createSelector(
  state,
  (state: IMemberJoinState) => state.errorPage
);

export const memberJoin_ErrorUpdating = createSelector(
  state,
  (state: IMemberJoinState) => state.errorUpdating
);

export const memberJoin_Completed = createSelector(
  state,
  (state: IMemberJoinState) => state.completed
);

export const memberJoin_CenterContent = createSelector(
  state,
  (state: IMemberJoinState) => {
    return state.currentStep !== 6 && state.currentStep !== 7
  }
);